import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { ILinkProps, ImdsColumnKeys, IDrillThruRowData, DrillThruComponentType, LinkResult } from './DrillThruTypes'
import LinkSetupLogic from './LinkSetupLogic'
import HighTextLinkDisplay from './HighTextLinkDisplay'
import DrillThruTableRowDisplay from './DrillThruTableRowDisplay'

function LinkSetup(props: IDrillThruRowData) {
    // Hooks
    // const [result, setResult] = useState<JSX.Element | null>(null)
    const [linkData, setLinkData] = useState<LinkResult | null>(null);
    const LinkSetUpCallBack = (OcvDetails: any) => {
        props.LinkSetUpCallBack(OcvDetails)
      }

    useEffect(() => {
        let indexval = props.headerText;
        let currentColumn: ImdsColumnKeys = props?.formedColumn[indexval?indexval:-1] || -1;

        if (currentColumn) {
            const fetchLinkLogic = async () => {
                const LinkLogicResponse = await LinkSetupLogic({
                    formedColumn: props.formedColumn,
                    currentColumn,
                    cellTitle: '',
                    functionParamsString: '',
                    isAllowedOCV: true,
                    tableHeading: props.tableHeading,
                    JSONRowDataLists: props.JSONRowDataLists,
                    rowCounter: props.rowCounter,
                    colCounter: props.colCounter,
                    vuId: props.vuId,
                    headerText: props.headerText,
                    rowObject: props.rowObject,
                    mdsColumnData: props.mdsColumnData,
                    drillThruVUObj: props.drillThruVUObj,
                    data_isEnabledAutoNavigation: props.data_isEnabledAutoNavigation,
                    data_drillThruSearchObj: props.data_drillThruSearchObj,
                    LinkSetUpCallBack: LinkSetUpCallBack
                });
                if (LinkLogicResponse) {
                    // Save data in the state
                    setLinkData(LinkLogicResponse as LinkResult );
                }
            };

            fetchLinkLogic();
        }
    }, [props.headerText, props.set_drillThruComponentType, props.JSONRowDataLists, props.rowCounter, props.colCounter, props.vuId]);
    if (!linkData) return (<td
        className="left"
        data-column-name={String(props.headerText)}
        style={{
            ...(props.colCounter === 0
                ? { position: 'sticky', left: '0px', zIndex: 4, background: 'none' }
                : props.colCounter === 1
                    ? { position: 'sticky', left: `${props.firstColumnWidth}px`, zIndex: 3, background: 'none' }
                    : {}),
        }}
        key={props.headerText}></td>)
    return (
        <>
            {props.set_drillThruComponentType === DrillThruComponentType.HighlightDrillThru && (
                <HighTextLinkDisplay
                    headerText={String(props.headerText)}
                    id={linkData?.LinkValues?.id}
                    href={linkData?.LinkValues?.href}
                    isLink={linkData.IsLink}
                    onClick={linkData?.LinkValues?.onClick}
                    valText={props.valText ? props.valText : ''}
                />
            )}
            {props.set_drillThruComponentType === DrillThruComponentType.DrillThruTableRow && (
                <DrillThruTableRowDisplay
                    headerText={String(props.headerText)}
                    id={linkData?.LinkValues?.id}
                    href={linkData?.LinkValues?.href}
                    isLink={linkData?.IsLink}
                    onClick={linkData?.LinkValues?.onClick}
                    valText={props.valText ? props.valText : ''}
                    colCounter={props.colCounter}
                    cellRef={props.cellRef}
                    firstColumnWidth={props.firstColumnWidth}
                    onContextMenu={linkData?.LinkValues?.onContextMenu}
                />
            )}
        </>
    );
}

LinkSetup.propTypes = {
    set_drillThruComponentType: PropTypes.oneOf([
        DrillThruComponentType.DrillThruTableRow,
        DrillThruComponentType.HighlightDrillThru
    ]).isRequired
}

export default LinkSetup
